<script>
import { ref, reactive, watch, onMounted, computed } from 'vue';
import { useAppDataStore } from '../stores/appDataStore';
import InputChoice from './InputChoice.vue';
import DatePicker from 'vue-datepicker-next';
import Toggle from '@vueform/toggle';
import JQuery from 'jquery'
let $j = JQuery
import { parseDate } from '../helpers/dateHelper';

export default {
  components: {
    InputChoice,
    DatePicker,
    Toggle
  },
  props: {
    handleIframeHeight: {
      type: Function
    }
  },
  setup(props) {
    const appDataStore = useAppDataStore();
    const appData = computed(() => appDataStore.appData);
    const showPopup = ref(false);
    let s7 = appData.value.s7;
    let time_buttons = reactive([]);
    const meetingTimeSelectedDateCut = (date) => date?.slice(0, 2) ?? '-';

    const meetingTimeGetMonthName = (month) => {
      if (month != null) {
        let monthNumber = month.slice(3, 5);
        const date = new Date();
        date.setMonth(monthNumber - 1);
        let result = date.toLocaleString('de-DE', {
          month: 'long',
        });
        result = result + ', ' + month.slice(6, 10);
        return result;
      }
      return '-';
    };

    const showTime = () => {
      const meetingTime = appData.value.contact.meeting_times_api?.find(item => item.date === s7.value);

      if (meetingTime) {
        s7.capacity = meetingTime.options;
        appData.value.contact.meeting_times_input = 'FALSCH';
        return true;
      }

      appData.value.contact.meeting_times_input = 'WAHR';
      return false;
    };

    const handleTimes = () => {
      time_buttons = [];

      if (appData.value.contact.meeting_times_api) {
        const selectedDateTimes = appData.value.contact.meeting_times_api
          .filter(item => item.date === s7.value && item.available > 0)
          .map(item => ({
            name: `${item.startTime} - ${item.endTime}`,
            value: `${item.startTime} - ${item.endTime}`,
            className: 'icon--clock'
          }));

        selectedDateTimes.forEach(newItem => {
          const isDuplicate = time_buttons.some(
            existingItem => existingItem.value === newItem.value
          );
          if (!isDuplicate) {
            time_buttons.push(newItem);
          }
        });

        return time_buttons.length > 0 ? time_buttons : false;
      }

      return false;
    };


    const exceptionDates = computed(() => {
      return appData.value.meeting_times_exceptions_not_api;
    });

    const disablePastDate = (date) => {
      // Exclude exceptions if their capacity is 0
      let dateTitle = date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate();

      const ExceptionDateTitle = String(date.getDate()).padStart(2, '0') + '.' + (String(date.getMonth() + 1).padStart(2, '0')) + '.' + date.getFullYear();
      let except = exceptionDates?.value.find(exception => exception.date == ExceptionDateTitle && exception.capacity == 0);

      if (except) {
        return true;
      }

      if (s7.value) {
        let currentActiveDate = new Date(parseDate(s7.value));
        if (currentActiveDate.getFullYear()+'-'+currentActiveDate.getMonth()+'-'+currentActiveDate.getDate() ==
          date.getFullYear()+'-'+date.getMonth()+'-'+date.getDate()) {
          return false;
        }
      }

      const today = new Date();
      //to disable today and show only next day
      today.setDate(today.getDate() + 1);
      today.setHours(0, 0, 0, 0);
      if (date < today) {
        return true;
      }

      let publicHoliday = appData.value.contact.public_holidays;
      for (let key in publicHoliday) {
        // Convert the date format
        let publicHolidayParts = publicHoliday[key].split('-');
        let publicHolidayAttrDate = `${publicHolidayParts[2]}.${parseInt(publicHolidayParts[1])}.${parseInt(publicHolidayParts[0])}`;
        let parsedHolidayDate = parseDate(publicHolidayAttrDate);
        if (parsedHolidayDate.getFullYear()+'-'+parsedHolidayDate.getMonth()+'-'+parsedHolidayDate.getDate() ==
          date.getFullYear()+'-'+date.getMonth()+'-'+date.getDate()) {
          return true;
        }

        if(document.querySelector('td.cell[title="'+ publicHolidayAttrDate +'"]') != null) {
          document.querySelector('td.cell[title="'+ publicHolidayAttrDate +'"]').setAttribute("weekend", publicHolidayAttrDate);
          document.querySelector('td.cell[title="'+ publicHolidayAttrDate +'"]').setAttribute("custom-disabled", "true");
        }
      }

      if (appData.value.datepickerFlag == false) {
        let td = document.querySelectorAll('.mx-table .cell');
        for (let i = 0; i < td.length; i++) {
          td[i].removeAttribute('custom-enabled');
        }
        setTimeout(() => {
          let cells = document.querySelectorAll('.mx-table .cell');
          for (let i = 0; i < cells.length; i++) {
            cells[i].setAttribute("custom-disabled", "true");
          }
        }, 0);
      }
      //check if the date is saturday or sunday and add class
      if (date.getDay() == 0 || date.getDay() == 6) {
        let dateTitle = date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate();
        let tdWeekend = document.querySelectorAll('.mx-table .cell[title="'+dateTitle+'"]');
        for (let i = 0; i < tdWeekend.length; i++) {
          tdWeekend[i].setAttribute('weekend', dateTitle);
        }
      }
      //check if the date is in meeting_times_api array, and add class custom enabled that removes red highlight
      if (appData.value.contact.meeting_times_api) {

        for (let i = 0; i < appData.value.contact.meeting_times_api.length; i++) {
          if (appData.value.contact.meeting_times_api[i].available > 0) {

            let myDate = new Date(parseDate(appData.value.contact.meeting_times_api[i]['date']));
            let myFormatedDate = myDate.getFullYear() + '-' + (myDate.getMonth() + 1) + '-' + myDate.getDate();

            if (myDate.getFullYear()+'-'+myDate.getMonth()+'-'+myDate.getDate() ==
              date.getFullYear()+'-'+date.getMonth()+'-'+date.getDate()) {

              setTimeout(() => {
                let td = document.querySelectorAll('.mx-table .cell');
                for (let i = 0; i < td.length; i++) {
                  if (myFormatedDate === td[i].getAttribute('title')) {
                    td[i].setAttribute('custom-enabled', 'true');
                  }
                }
              }, 0)
            }
          }
        }

        return false;
      }
      return true;
    }
    const closePopup = () => {
      showPopup.value = !showPopup.value;
    };

    onMounted(() => {});
    // Watcher for appData.s7 changes
    watch(() => s7, () => {
      props.handleIframeHeight();
    }, { deep: true });
    watch(() => s7.value, () => {
      s7.meeting_time = '';
      if (appData.value.contact.meeting_times_api) {
        //show label if day is weekend
        let s7Value = s7.value;
        let s7ValueArray = s7Value.split('.');
        let s7ValueDate = new Date(s7ValueArray[2], s7ValueArray[1]-1, s7ValueArray[0]);
        setTimeout(() => {
          for (let i = 0; i < appData.value.contact.meeting_times_api.length; i++) {
            if (appData.value.contact.meeting_times_api[i]['date'] != s7Value) {
              $j('.cell[weekend]').each(function () {
                let dateWeekend = $j(this).attr('weekend').split('-');
                dateWeekend = new Date(dateWeekend[0], dateWeekend[1]-1, dateWeekend[2]);
                if (s7ValueDate.getTime() === dateWeekend.getTime()) {
                  $j('.meeting-time-weekend').show();
                  $j('.meeting-time-picker').hide();
                  $j('.meeting-time-selected').hide();
                  return false;
                } else {
                  $j('.meeting-time-weekend').hide();
                  $j('.meeting-time-picker').show();
                  $j('.meeting-time-selected').show();
                }
              });
            } else {
              $j('.meeting-time-weekend').hide();
              $j('.meeting-time-picker').show();
              $j('.meeting-time-selected').show();
              return false;
            }
          }
          //show popup, if selected red date and if NOT weekend
          let result = false;
          let titleFormatDate = s7ValueArray[2] + '-' + parseInt(s7ValueArray[1]) + '-' + parseInt(s7ValueArray[0]);
          if ($j('.cell[weekend="' + titleFormatDate + '"]').length == 0) {
            appData.value.contact.meeting_times_api.forEach(
              (meetingDay) => {
                if (meetingDay.date === s7.value) {
                  return result = false;
                }
                result = true;
              }
            );
          }
          if (result) {
            closePopup();
          }
        }, 0);
      }
    });

    watch(() => appData.value.contact.termin_select, () => {
      props.handleIframeHeight();

      const today = new Date();
      today.setHours(0, 0, 0, 0); // Reset time to 00:00 for accurate date comparison

      const selectedDate = appData.value.contact.meeting_times_api.find(item => {
        const [day, month, year] = item.date.split('.');
        const apiDate = new Date(`${year}-${month}-${day}`);
        apiDate.setHours(0, 0, 0, 0); // Normalize time to 00:00

        // Check if apiDate is not a public holiday
        const isHoliday = appData.value.contact.public_holidays.some(holiday => {
          const holidayDate = new Date(holiday);
          holidayDate.setHours(0, 0, 0, 0);
          return apiDate.getTime() === holidayDate.getTime();
        });

        // Check if apiDate is in the future or today and not a holiday
        return apiDate.getTime() >= today.getTime() && !isHoliday;
      });

      if (selectedDate) {
        s7.value = selectedDate.date;
      } else {
        s7.value = null; // or handle the case when no future date is found
      }
    });
    return {
      appData,
      s7,
      showPopup,
      exceptionDates,
      meetingTimeSelectedDateCut,
      meetingTimeGetMonthName,
      showTime,
      handleTimes,
      disablePastDate,
      closePopup
    }
  }
}
</script>

<template>
  <div v-if="appData.contact.meeting_times_api && appData.orderType != 'Unverbindliche Anfrage'">
    <h6 class="sub-title sub-title--terminauswahl">Terminauswahl (optional)</h6>
    <h6>Sie können direkt online ein verfügbares Wunschzeitfenster für die Installation auswählen.</h6>

    <div class="stepper__input">
      <Toggle v-model="appData.contact.termin_select" class="toggle-blue" />
      <label class="checkbox-title switch-label"><h6>Jetzt Wunschtermin für die Installation wählen</h6></label>
    </div>
    <h6>Bitte wählen Sie hier einen freien Termin aus. Diese werden im Kalender weiß dargestellt.</h6>
    <div v-if="appData.contact.termin_select" class="terminauswahl-wrapper">
      <div v-if="appData.contact.termin_select && appData.contact.meeting_times_api">
        <div class="meeting-time-block">
          <div class="meeting-time-wrapper">
            <Transition>
              <div v-if="showPopup" class="meeting-time-popup-bg" @click="closePopup()"></div>
            </Transition>
              <div v-if="showPopup" class="meeting-time-popup">
                <i class="icon icon--not-checked" @click="closePopup()" />
                Wenn Sie einen Termin an einem Tag auswählen möchten, der bereits vollständig ausgebucht ist, senden Sie uns gern Ihren Wunsch bezüglich Datum und Uhrzeit. Wir werden Sie zurückrufen und versuchen, Ihren Termin möglich zu machen.
              </div>
            <div class="mobile-meeting-time-stepper mobile-meeting-time-stepper--first">
              <span>1</span>
            </div>
            <div class="date-picker-wrapper">
              <date-picker
                v-model:value="s7.value"
                :default-value="new Date()"
                :disabled-date="disablePastDate"
                type="date"
                :editable="false"
                :open="true"
                placeholder="Datum wählen"
                format="DD.MM.YYYY"
                title-format="YYYY-M-D"
                value-type="format"
                class="active-picker"
                :append-to-body="false"
              />
            </div>
            <div class="mobile-meeting-time-stepper">
              <span>2</span>
            </div>
            <div class="meeting-time-picker">
              <i class="icon--clock icon icon--button"></i>
              <span>Zeit</span>
              <p v-show="!showTime()">Schreiben Sie Ihr bevorzugtes Zeitfenster auf:</p>
              <p v-show="showTime()">Wählen Sie ein verfügbares Zeitfenster</p>
              <div v-show="showTime()" class="meeting_time_buttons">
                <InputChoice
                  v-model="s7.meeting_time"
                  :value="s7.meeting_time"
                  :options="handleTimes()"
                />
                <span class="icon icon--sort-up help is-danger">Ist ein Pflichtfeld.</span>
              </div>
              <div v-show="!showTime()" class="meeting-times-input">
                <input v-model="s7.meeting_time" type="time">
              </div>
            </div>
            <div class="meeting-time-weekend">
              <h6>Am Wochenende sind leider keine Wunschzeitfenster möglich</h6>
            </div>
            <div class="mobile-meeting-time-stepper">
              <span><i class="icon icon--check"></i></span>
            </div>
            <div v-show="s7.value" class="meeting-time-selected">
              <h4>IHR EINTRAG</h4>
              <div class="meeting-time-selected-date">
                {{ meetingTimeSelectedDateCut(s7.value) }}
              </div>
              <div class="meeting-time-selected-month">
                {{ meetingTimeGetMonthName(s7.value) }}
              </div>
              <div v-show="s7.meeting_time" class="meeting-time-selected-time">
                {{ s7.meeting_time }}
              </div>
              <div v-show="!s7.meeting_time" class="meeting-time-selected-time">
                ...
              </div>
            </div>
          </div>
        </div>
        <h6>Sollte Ihnen keiner der freien Termine möglich sein, wählen Sie im Kalender Ihren Wunschtermin (Datum und Uhrzeit) aus und wir melden uns nach Eingang Ihrer Anfrage telefonisch bei Ihnen.</h6>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  /* Date Picker [Step 6] */
  .mx-datepicker-popup {
    left: -15px!important;
    top: 0!important;
    z-index: 1;
  }
  .mx-input-wrapper {
    display: none!important;
  }
  .date-picker-wrapper {
    height: 300px;
  }
  .root .mx-datepicker {
    margin: 0;
  }
  .root .mx-datepicker td.cell.disabled {
    pointer-events: none;
  }
  .meeting-time-popup-bg {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.9);
    z-index: 998;
  }
  .meeting-time-popup {
    position: fixed;
    max-width: 670px;
    width: 100%;
    padding: 25px;
    background: #D9DAE2;
    border-radius: 10px;
    z-index: 999;
    color: #000548;
    font-family: "Maven Pro";
    font-size: 16px;
    font-weight: 600;
    left: calc(50% - 335px);
    top: calc(50% - 58px);
    i {
      cursor: pointer;
      position: absolute;
      right: 10px;
      top: 5px;
      font-style: normal;
      &:after {
        font-size: 21px;
      }
    }
  }
  @media only screen and (min-width: 768px) {
    .meeting-time-picker {
      margin-left: 30px;
    }
  }
  @media only screen and (max-width: 700px) {
    .meeting-time-popup {
      left: 1%;
      width: 98%;
    }
    .root .mx-datepicker {
      margin: 0;
    }
    .meeting-time-wrapper {
      flex-wrap: wrap;
      justify-content: center;
    }
    .meeting-time-picker {
      width: 100%;
      p {
        max-width: 100%;
      }
      >i {
        display: inline-block;
        margin: 0;
        top: 0;
      }
    }
    .meeting-time-selected {
      margin-top: 0;
      max-width: 250px;
      width: 100%;
    }
    .root .progress-meeting-time {
      display: none;
    }
    .mobile-meeting-time-stepper {
      display: block;
      position: relative;
      width: 100%;
      margin: 70px 0 20px 0;
      &--first {
        margin-top: 25px;
        span {
          &:before,
          &:after {
            display: none;
          }
        }
      }
      i {
        color: #ffffff;
        font-style: normal;
      }
      span {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: auto;
        width: 28px;
        height: 28px;
        background: #000548;
        border-radius: 60px;
        color: #ffffff;
        font-weight: 700;
        font-size: 16px;
        &:before {
          content: "";
          position: absolute;
          border-top: 2px dotted #000548;
          width: 30px;
          transform: rotate(90deg);
          top: -30px;
        }
        &:after {
          content: "";
          position: absolute;
          width: 10px;
          height: 10px;
          border-radius: 100%;
          background: #000548;
          top: -15px;
        }
      }
      &:first-child {
        margin-top: 20px;
        span {
          &:after,
          &:before {
            display: none;
          }
        }
      }
    }
  }
  @media only screen and (max-width: 968px) {
    .meeting-time-popup {
      top: calc(40% - 58px);
    }
  }
  @media only screen and (max-width: 600px) {
    .meeting-time-popup {
      top: calc(20% - 58px);
    }
    .mx-datepicker {
      width: 270px;
    }
    .mx-datepicker-popup {
      z-index: 1;
    }
  }
</style>
